import { isBrowser } from 'utils/environment';

export const AB_TEST_KEYS = [
  'cart.isDiscountInputHidden',
  'cart.isDiscountPercentageVisible',
  'cart.isTrustPointsVisible',
  'cart.isInfoBulletsVisible',
  'cart.isFreeShippingProgressVisible',
] as const;

export type ABTestKey = (typeof AB_TEST_KEYS)[number];

const OVERRIDE_PARAM = 'ab';
const OVERRIDE_STORAGE_PREFIX = 'timelineAB:';

declare global {
  interface Window {
    timelineAB?: string[];
  }
}

const listeners = new Set<() => void>();

const getQueue = () => {
  window.timelineAB ??= [];
  const queue = window.timelineAB;

  if (!Object.hasOwn(queue, 'push')) {
    queue.push = (...keys) => {
      const length = Array.prototype.push.apply(queue, keys);
      listeners.forEach((listener) => listener());
      return length;
    };
  }

  return queue;
};

export const subscribeToABTests = (listener: () => void) => {
  getQueue();
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

const isOverridden = (key: ABTestKey) => {
  const isInUrl = new URLSearchParams(window.location.search)
    .getAll(OVERRIDE_PARAM)
    .includes(key);

  try {
    if (isInUrl) {
      sessionStorage.setItem(`${OVERRIDE_STORAGE_PREFIX}${key}`, '1');
    }
    return sessionStorage.getItem(`${OVERRIDE_STORAGE_PREFIX}${key}`) === '1';
  } catch {
    return isInUrl;
  }
};

export const getIsABTestActive = (key: ABTestKey) => {
  if (!isBrowser) return false;

  return isOverridden(key) || getQueue().includes(key);
};
